import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Button } from '@mui/material';
import { GridFooter, GridFooterContainer, GridSlotsComponentsProps } from '@mui/x-data-grid-pro';

import { CustomFooterSummary } from 'components/grid/components/CustomFooterSummary';

declare module '@mui/x-data-grid-pro' {
    interface FooterPropsOverrides {
        refresh?: false | (() => void);
        hideFooter?: boolean;
        summary: string[];
        summaryPrefix?: string | boolean;
    }
}

export function CustomFooter({ refresh, summary = [], summaryPrefix, hideFooter }: NonNullable<GridSlotsComponentsProps['footer']>) {
    if (hideFooter) {
        return null;
    }

    return (
        <GridFooterContainer
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
            }}
        >
            {Boolean(summary?.length) && <CustomFooterSummary summary={summary} summaryPrefix={summaryPrefix} />}

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }}
            >
                {refresh && (
                    <Button
                        onClick={refresh}
                        color="inherit"
                        size="small"
                        sx={{ textTransform: 'none', fontWeight: 'normal', fontSize: '0.875rem' }}
                        startIcon={<RefreshIcon fontSize="small" />}
                    >
                        Recarregar dados
                    </Button>
                )}

                <GridFooter sx={{ border: 'none' }} />
            </Box>
        </GridFooterContainer>
    );
}
